import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNext = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 50,
	height: 51,
	viewBox: "0 0 50 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.508 43.6667L16 40.1667L31.029 25.1917L16 10.1677L19.508 6.66666L34.535 21.6397C36.485 23.5787 36.489 26.7407 34.544 28.6877L19.508 43.6667Z",
		fill: "#002938"
	})
});
const ForwardRef = forwardRef(SvgNext);
export default ForwardRef;
